module.exports = __webpack_public_path__ + "static/media/retail-fp_phsag5.adb743d0.jpg";